import { Box, InputAdornment, TextField, useTheme } from '@mui/material';
import { ChangeEvent, FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import InputMask from 'react-input-mask';
import { ValidationCreditCardType } from '@/logic/hooks';
import ImageBoxFuture from '../image-box-future';
import { CheckoutCvvInputInfo } from '@/components/checkout/checkout-cvv-input-info';

interface CreditCardCvvInputProps {
  creditCardType: ValidationCreditCardType;
  creditCardCvv: string;
  isCreditCardCvvValid: boolean;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  isLoading?: boolean;
}

export const CreditCardCvvInput: FC<CreditCardCvvInputProps> = ({
  creditCardType,
  creditCardCvv,
  isCreditCardCvvValid,
  handleChange,
  isLoading = false,
}) => {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <Box>
      <InputMask
        mask={creditCardType === 'american-express' ? '9999' : '999'}
        maskChar=''
        disabled={isLoading}
        value={creditCardCvv}
        onChange={handleChange}
      >
        {() => (
          <TextField
            id='credit-card-cvv'
            label={<FormattedMessage id='my_credit_cards.cvv' />}
            disabled={isLoading}
            dir='ltr'
            sx={{
              legend: {
                width: 0,
              },
            }}
            InputProps={{
              sx: {
                color: theme.palette.grey[80],
              },
              endAdornment: (
                <InputAdornment
                  position='end'
                  sx={{
                    width: '49px',
                    height: '39px',
                  }}
                >
                  <ImageBoxFuture
                    img='/icons/credit-cards/cvv-placeholder-card.svg'
                    title={intl.formatMessage({
                      id: 'alt.credit_card_icon',
                    })}
                    objectFit='contain'
                    sx={{
                      width: '100%',
                      height: '100%',
                    }}
                  />
                </InputAdornment>
              ),
            }}
            InputLabelProps={{
              sx: {
                backgroundColor: 'white',
                paddingInline: '6px',
              },
              shrink: true,
            }}
            inputProps={{
              inputMode: 'numeric',
            }}
            error={!isCreditCardCvvValid && Boolean(creditCardCvv)}
            helperText={
              !isCreditCardCvvValid &&
              Boolean(creditCardCvv) && (
                <FormattedMessage id='my_credit_cards.cvv.invalid' />
              )
            }
          />
        )}
      </InputMask>
      <CheckoutCvvInputInfo />
    </Box>
  );
};
